import React from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"

const InfoBox = (props) => {
  return (
    <Panel hasFooter={false} noHeader id={props.id} className={"infobox"}>
      <Block className="infobox-img-container">
        <Image path={props.img} className="infobox-img" />
      </Block>

      <Element type="p" className="infobox-text1">{props.text1}</Element>
      <Element type="p" className="infobox-text2">{props.text2}</Element>
    </Panel>
  )
}

export default InfoBox
